import { render, staticRenderFns } from "./Horario.vue?vue&type=template&id=0f79c1ea&"
import script from "./Horario.vue?vue&type=script&lang=js&"
export * from "./Horario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports